<template>
  <v-footer color="white" padless>
    <v-layout justify-center wrap >
      <v-flex white lighten-2 py-1 pr-5 text-end dark--text xs12 class="overline">
        {{ new Date().getFullYear() }} — <strong>FUSION ®</strong>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
  export default {
    data() {
      return {
        links: [
          {name: 'Home', path: '/'},
          {name: 'About Us', path: '/about'},
          {name: 'Team', path: '/team'},
          {name: 'Services', path: '/services'},
          {name: 'Blog', path: '/blog'},
          {name: 'Contact Us', path: '/contact'},
        ],
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>